import Button from '@mui/material/Button';
import Dialog from '@mui/material/Dialog';
import DialogActions from '@mui/material/DialogActions';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import Stack from '@mui/material/Stack';

import { Identificador } from './Identificador';

/**
 * NENHUMA ação externa sem clique humano explícito.
 *
 * Este diálogo é o mecanismo dessa regra no front. Ele diz o que vai
 * acontecer, para quem, e com qual correlation_id — porque confirmar sem
 * saber o que se confirma não é consentimento, é fricção.
 *
 * O botão de confirmar NÃO é o padrão do teclado de propósito: Enter
 * distraído não pode disparar saída externa.
 */
export function ConfirmacaoHumana({
  aberto,
  titulo,
  descricao,
  correlationId,
  rotuloDeConfirmar = 'Confirmar',
  aoConfirmar,
  aoCancelar,
  ocupado = false,
  confirmarDesabilitado = false,
  children,
}: {
  aberto: boolean;
  titulo: string;
  descricao: string;
  correlationId?: string;
  rotuloDeConfirmar?: string;
  aoConfirmar: () => void;
  aoCancelar: () => void;
  ocupado?: boolean;
  /** O que a pessoa ainda precisa preencher antes de confirmar (ex.: escolher os grupos da admissão). */
  confirmarDesabilitado?: boolean;
  /** Campos da confirmação, abaixo da descrição. */
  children?: React.ReactNode;
}): React.JSX.Element {
  return (
    <Dialog open={aberto} onClose={ocupado ? undefined : aoCancelar} aria-labelledby="titulo-da-confirmacao" maxWidth="xs" fullWidth>
      <DialogTitle id="titulo-da-confirmacao">{titulo}</DialogTitle>
      <DialogContent>
        <Stack spacing={1}>
          <DialogContentText variant="body2">{descricao}</DialogContentText>
          {children}
          {correlationId !== undefined ? (
            <DialogContentText variant="caption" component="div">
              correlation_id: <Identificador valor={correlationId} />
            </DialogContentText>
          ) : null}
        </Stack>
      </DialogContent>
      <DialogActions>
        <Button onClick={aoCancelar} disabled={ocupado}>
          Cancelar
        </Button>
        <Button onClick={aoConfirmar} variant="contained" disabled={ocupado || confirmarDesabilitado}>
          {rotuloDeConfirmar}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
